/* ⚛ REACT */
import { useRef, useState, useEffect } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🎨 STYLES */
import { DateInput, DatepickerConatiner } from "./styles";

/* 🔧 UTILS */
import { getDataString } from "../../../../util/Months";

const Datepicker = ({ id, currentDate, setCurrentDate, changeDay, changeMonthYear, day, month, year, isLoadingDays, Mode }) => {

    const { t } = useTranslation();
    const inputRef = useRef(null);
    
    const [inputValue, setInputValue] = useState(new Date());

    useEffect(() => {
        setCurrentDate(inputValue);
    }, [inputValue, setCurrentDate])

    return (
        <DatepickerConatiner onClick={() => !isLoadingDays && inputRef.current?.showPicker()}>
            <DateInput 
                type="date"
                id={`graphDate ${id}`}
                name="graphDate"
                ref={inputRef}
                readOnly={isLoadingDays}
                value={new Date(year+'/'+month+'/'+day).toISOString().slice(0, 10)}
                max={getDataString(new Date().getFullYear())+'-'+getDataString(new Date().getMonth()+1)+'-'+getDataString(new Date().getDate())}
                onChange={(e) => {
                    if(e.target.value){
                        let date = new Date(e.target.value+'T21:00:00');
                        setInputValue(date);
                        if(getDataString(date.getMonth()+1) === month &&
                        date.getFullYear() === year && parseInt(Mode) === 0){
                                changeDay(getDataString(date.getDate()));
                        }else{
                            changeMonthYear(
                                getDataString(date.getDate()),
                                getDataString(date.getMonth()+1),
                                date.getFullYear()
                            );
                        }
                    }
                }}
            />
            <span>{ t("date.short-date", {date: new Date(currentDate)}) }</span>
        </DatepickerConatiner>
    );
};

export default Datepicker;